export const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect'

export function savePostLoginRedirect(redirect: string): void {
  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, redirect)
}

export function consumePostLoginRedirect(): string | null {
  const redirect = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
  if (redirect) {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
  }
  return redirect
}

export function parseRedirectTarget(redirect: string): { path: string; query: Record<string, string> } {
  const [path, search = ''] = redirect.split('?')
  const query: Record<string, string> = {}

  if (search) {
    new URLSearchParams(search).forEach((value, key) => {
      query[key] = value
    })
  }

  return { path, query }
}

export function getRedirectPath(redirect: string): string {
  return redirect.split('?')[0]
}
